import { render, staticRenderFns } from "./RepSemanalVentas.vue?vue&type=template&id=5bc76eb2"
import script from "./RepSemanalVentas.vue?vue&type=script&lang=js"
export * from "./RepSemanalVentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports